import React, { ComponentProps, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import {
  CheckBoxParam,
  Form,
  Option,
  Row,
  Select,
  SelectParam,
  SonForm,
  SubmitButton,
  Switch,
  useForm,
} from '../../../_lib/Form2';
import { Namespace } from '../../../translation/namespace';
import { Form2Modifier } from '../../../_lib/Form2/Form';
import { SwitchModifier } from '../../../_lib/Form2/elements/Switch/Switch';

type RoleSettingsFormProps = {
  form: SonForm<CheckBoxParam<string> | SelectParam<'manualAssignmentType'>>;
};

function RoleSettingsEdit({ form }: RoleSettingsFormProps) {
  const { t } = useTranslation(Namespace.RoleSettingsForm);
  const { formProps, params, fetchState } = useForm({
    form,
  });
  // Most elements are checkboxes except for two text elements.
  // So instead of getting each individual element via getByName(),
  // and because the order from BE is already correct, we can just check the type of the element.
  const allCheckboxes = params.getAllByType('checkbox');
  const manualAssignmentTypeParam = params.findByName('manualAssignmentType');

  const formId = useId();

  return (
    <Form id={`role-settings-form-${formId}`} modifier={Form2Modifier.NO_PADDING_BOTTOM} {...formProps}>
      {manualAssignmentTypeParam && (
        <Row key={manualAssignmentTypeParam.name}>
          <Select label={t(`inputs.${manualAssignmentTypeParam.name}.label`)} param={manualAssignmentTypeParam}>
            {manualAssignmentTypeParam.options.map(option => (
              <Option
                key={option.value}
                value={option.value}
                selected={option.value === manualAssignmentTypeParam.value}
              >
                {t(`inputs.${manualAssignmentTypeParam.name}.values.${option.value}`)}
              </Option>
            ))}
          </Select>
        </Row>
      )}
      {allCheckboxes?.map(checkbox => (
        <Row key={checkbox.name}>
          <Switch
            label={t(`inputs.${checkbox.name}.label`)}
            param={checkbox}
            modifierLabel={SwitchModifier.POSITION_INHERIT}
          />
        </Row>
      ))}
      <Row>
        <SubmitButton
          buttonLabel={t('Form:save')}
          messageSuccess={t('Form:status.success')}
          messageSending={t('Form:status.sending')}
          messageFail={t('Form:status.fail')}
          fetchState={fetchState}
        />
      </Row>
    </Form>
  );
}
export const RoleSettingsEditView = asFetchableView(RoleSettingsEdit);
export type RoleSettingsEditView = ComponentProps<typeof RoleSettingsEdit>;
